import { useState } from 'react';

export const UseImageHovering = (stylesForHovering) => {
  const [hovered, setHovered] = useState();
  const onHover = () => setHovered(true);
  const onBlur = () => setHovered(false);
  const frontImageOnHover = hovered ? stylesForHovering.frontImageOnHover : '';
  const backImageOnHover = hovered ? stylesForHovering.backImageOnHover : '';

  return {
    onHover, onBlur, frontImageOnHover, backImageOnHover,
  };
};
